var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg486",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6, .cls-7, .cls-11 {\n        opacity: .2;\n      }\n\n      .cls-1, .cls-3, .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-5, .cls-13, .cls-14, .cls-10, .cls-15 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        filter: url(#filter4483-2);\n      }\n\n      .cls-16 {\n        fill: #d6c84a;\n      }\n\n      .cls-17, .cls-13 {\n        fill: #3f3f3f;\n      }\n\n      .cls-4 {\n        stroke-width: 12.87px;\n      }\n\n      .cls-4, .cls-8 {\n        stroke: #000;\n        stroke-miterlimit: 8.11;\n      }\n\n      .cls-4, .cls-8, .cls-18 {\n        fill: none;\n      }\n\n      .cls-4, .cls-8, .cls-9, .cls-10, .cls-12 {\n        opacity: .1;\n      }\n\n      .cls-6 {\n        filter: url(#filter4516);\n      }\n\n      .cls-7 {\n        filter: url(#filter4512);\n      }\n\n      .cls-8 {\n        stroke-width: 17.16px;\n      }\n\n      .cls-18 {\n        stroke: #3f3f3f;\n        stroke-linecap: round;\n        stroke-miterlimit: 2.15;\n        stroke-width: 4.29px;\n      }\n\n      .cls-14 {\n        fill: #cbbb2e;\n      }\n\n      .cls-12 {\n        filter: url(#filter4483);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter4483",
    x: -0.022428717,
    y: -0.025808025,
    width: 1.0448574,
    height: 1.0516161
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2249721
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4483-2",
    "data-name": "filter4483",
    x: -0.022428717,
    y: -0.025808025,
    width: 1.0448574,
    height: 1.0516161
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2249721
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4516",
    x: -0.059999999,
    y: -0.059999999,
    width: 1.12,
    height: 1.12
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4512",
    x: -0.059999999,
    y: -0.059999999,
    width: 1.12,
    height: 1.12
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path4487",
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M125.38,32.45l15.99,16.06,14.84-14.84,55.05,55.05h27.11l10.28,23.13c1.51,3.22,.12,7.05-3.1,8.56-3.22,1.51-7.05,.12-8.56-3.1-.04-.08-.07-.15-.1-.23l-6.88-15.49h-14.61l-15.54,15.54v12.86l16,8.89c3.13,1.69,4.29,5.6,2.6,8.73-1.69,3.13-5.6,4.29-8.73,2.6-.04-.02-.08-.04-.12-.07l-22.62-12.57v-24.57l-38.72-38.72-48.98,48.78h1.88v94.4h8.58c8.58,0,8.58,8.58,8.58,8.58v17.16H6.75v-17.16c0-8.58,8.58-8.58,8.58-8.58h8.58V123.05H58.26l-11.88-11.92L125.38,32.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M125.38,32.45l15.99,16.06,14.84-14.84,55.05,55.05h27.11l10.28,23.13c1.51,3.22,.12,7.05-3.1,8.56-3.22,1.51-7.05,.12-8.56-3.1-.04-.08-.07-.15-.1-.23l-6.88-15.49h-14.61l-15.54,15.54v12.86l16,8.89c3.13,1.69,4.29,5.6,2.6,8.73-1.69,3.13-5.6,4.29-8.73,2.6-.04-.02-.08-.04-.12-.07l-22.62-12.57v-24.57l-38.72-38.72-48.98,48.78h1.88v94.4h8.58c8.58,0,8.58,8.58,8.58,8.58v17.16H6.75v-17.16c0-8.58,8.58-8.58,8.58-8.58h8.58V123.05H58.26l-11.88-11.92L125.38,32.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4480",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M125.38,32.45l15.99,16.06,14.84-14.84,55.05,55.05h27.11l10.28,23.13c1.51,3.22,.12,7.05-3.1,8.56-3.22,1.51-7.05,.12-8.56-3.1-.04-.08-.07-.15-.1-.23l-6.88-15.49h-14.61l-15.54,15.54v12.86l16,8.89c3.13,1.69,4.29,5.6,2.6,8.73-1.69,3.13-5.6,4.29-8.73,2.6-.04-.02-.08-.04-.12-.07l-22.62-12.57v-24.57l-38.72-38.72-48.98,48.78h1.88v94.4h8.58c8.58,0,8.58,8.58,8.58,8.58v17.16H6.75v-17.16c0-8.58,8.58-8.58,8.58-8.58h8.58V123.05H58.26l-11.88-11.92L125.38,32.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4353",
    className: "cls-14",
    d: "M125.38,30.31l15.99,16.06,14.84-14.84,60.08,60.08-24.27,24.27-43.75-43.75-48.98,48.78h1.88v111.57H23.91V120.9H58.26l-11.88-11.92L125.38,30.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4551",
    className: "cls-10",
    d: "M148.25,71.05l-48.98,48.78h1.08l47.9-47.71,43.75,43.75,24.27-24.27-.54-.54-23.74,23.74-43.75-43.75ZM46.92,108.45l-.54,.53,10.81,10.85h1.07l-11.34-11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4462",
    className: "cls-1",
    d: "M125.38,30.31l15.99,16.06,14.84-14.84,60.08,60.08-.54,.54-59.54-59.54-14.84,14.84-15.99-16.06L46.92,109.52l-.54-.54L125.38,30.31Zm-24.22,90.6v1.07h-1.88l1.08-1.07h.8Zm-43.96,0l1.07,1.07H23.91v-1.07H57.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect4425",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.53,80.14h0c-26.07,0-47.2,21.13-47.2,47.2h0c0,26.07,21.13,47.2,47.2,47.2h0c26.07,0,47.2-21.13,47.2-47.2h0c0-26.07-21.13-47.2-47.2-47.2Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "rect4359",
    className: "cls-16",
    x: 15.33,
    y: 206.73,
    width: 94.4,
    height: 21.46,
    rx: 8.58,
    ry: 8.58
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4363",
    className: "cls-17",
    d: "M109.74,215.31c8.58,0,8.58,8.58,8.58,8.58v17.16H6.75v-17.16c0-8.58,8.58-8.58,8.58-8.58H109.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4540",
    className: "cls-8",
    d: "M144.07,43.66L62.53,125.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4365",
    className: "cls-16",
    d: "M62.53,77.99h0c-26.07,0-47.2,21.13-47.2,47.2h0c0,26.07,21.13,47.2,47.2,47.2h0c26.07,0,47.2-21.13,47.2-47.2h0c0-26.07-21.13-47.2-47.2-47.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4501",
    className: "cls-3",
    d: "M62.53,91.94h0c-18.96,0-34.33,15.37-34.33,34.33h0c0,18.96,15.37,34.33,34.33,34.33h0c18.96,0,34.33-15.37,34.33-34.33h0c0-18.96-15.37-34.33-34.33-34.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4367",
    className: "cls-17",
    d: "M62.53,90.87h0c-18.96,0-34.33,15.37-34.33,34.33h0c0,18.96,15.37,34.33,34.33,34.33h0c18.96,0,34.33-15.37,34.33-34.33h0c0-18.96-15.37-34.33-34.33-34.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect4427",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.07,11.48h0c-18.96,0-34.33,15.37-34.33,34.33h0c0,18.96,15.37,34.33,34.33,34.33h0c18.96,0,34.33-15.37,34.33-34.33h0c0-18.96-15.37-34.33-34.33-34.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4542",
    className: "cls-4",
    d: "M144.07,43.66l55.78,55.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4373",
    className: "cls-16",
    d: "M144.07,9.33h0c-18.96,0-34.33,15.37-34.33,34.33h0c0,18.96,15.37,34.33,34.33,34.33h0c18.96,0,34.33-15.37,34.33-34.33h0c0-18.96-15.37-34.33-34.33-34.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4375",
    className: "cls-13",
    d: "M238.36,86.57l10.28,23.13c1.51,3.22,.12,7.05-3.1,8.56-3.22,1.51-7.05,.12-8.56-3.1-.04-.08-.07-.15-.1-.23l-6.88-15.49h-14.61l-15.54,15.54v12.86l16,8.89c3.13,1.69,4.29,5.6,2.6,8.73-1.69,3.13-5.6,4.29-8.73,2.6-.04-.02-.08-.04-.12-.07l-22.62-12.57v-25.76l23.08-23.08h28.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4499",
    className: "cls-3",
    d: "M144.07,18.99h0c-14.22,0-25.75,11.53-25.75,25.75h0c0,14.22,11.53,25.75,25.75,25.75h0c14.22,0,25.75-11.53,25.75-25.75h0c0-14.22-11.53-25.75-25.75-25.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4377",
    className: "cls-17",
    d: "M144.07,17.92h0c-14.22,0-25.75,11.53-25.75,25.75h0c0,14.22,11.53,25.75,25.75,25.75h0c14.22,0,25.75-11.53,25.75-25.75h0c0-14.22-11.53-25.75-25.75-25.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4379",
    className: "cls-9",
    d: "M62.53,103.74h0c-11.85,0-21.46,9.61-21.46,21.46h0c0,11.85,9.61,21.46,21.46,21.46h0c11.85,0,21.46-9.61,21.46-21.46h0c0-11.85-9.61-21.46-21.46-21.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4381",
    className: "cls-9",
    d: "M144.07,26.5h0c-9.48,0-17.16,7.68-17.16,17.16h0c0,9.48,7.68,17.16,17.16,17.16h0c9.48,0,17.16-7.68,17.16-17.16h0c0-9.48-7.68-17.16-17.16-17.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4415",
    className: "cls-3",
    d: "M62.53,77.99c26.15,0,47.2,21.05,47.2,47.2,0,.18,0,.36,0,.54-.29-25.9-21.22-46.67-47.19-46.67S15.63,99.83,15.34,125.73c0-.18,0-.36,0-.54,0-26.15,21.05-47.2,47.2-47.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4417",
    className: "cls-3",
    d: "M144.07,9.33c19.02,0,34.33,15.31,34.33,34.33,0,.18-.01,.36-.01,.54-.29-18.77-15.48-33.79-34.32-33.79s-34.03,15.02-34.32,33.79c0-.18-.01-.36-.01-.54,0-19.02,15.31-34.33,34.33-34.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4442",
    className: "cls-3",
    d: "M101.15,206.73c4.75,0,8.58,3.83,8.58,8.58v1.07c0-4.75-3.83-8.58-8.58-8.58H23.91c-4.75,0-8.58,3.83-8.58,8.58v-1.07c0-4.75,3.83-8.58,8.58-8.58H101.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4444",
    className: "cls-3",
    d: "M109.74,215.31c8.58,0,8.58,8.58,8.58,8.58v1.07s0-8.58-8.58-8.58H15.33s-8.58,0-8.58,8.58v-1.07c0-8.58,8.58-8.58,8.58-8.58H109.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4455",
    className: "cls-1",
    d: "M238.36,86.57l10.28,23.13c.48,1.02,.68,2.15,.58,3.28-.06-.76-.26-1.51-.58-2.2l-10.28-23.13h-28.31l-23.08,23.08v-1.07l23.08-23.08h28.31Zm-38.51,41.27l16,8.89c2.24,1.21,3.55,3.63,3.34,6.17-.19-2.15-1.44-4.07-3.34-5.1l-16-8.89v-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4489",
    className: "cls-11",
    d: "M144.07,17.92c14.26,0,25.75,11.48,25.75,25.75,0,.18,0,.36-.01,.54-.28-14.01-11.65-25.21-25.73-25.21s-25.45,11.2-25.73,25.21c0-.18-.01-.36-.01-.54,0-14.26,11.48-25.75,25.75-25.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4494",
    className: "cls-11",
    d: "M62.53,90.87c19.02,0,34.33,15.31,34.33,34.33,0,.18-.01,.36-.01,.54-.29-18.77-15.48-33.79-34.32-33.79s-34.03,15.02-34.32,33.79c0-.18-.01-.36-.01-.54,0-19.02,15.31-34.33,34.33-34.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4546",
    className: "cls-5",
    d: "M215.39,98.38l-15.54,15.54v1.07l15.54-15.54h14.61l6.88,15.49c1.39,3.27,5.17,4.79,8.45,3.4,2.54-1.08,4.11-3.67,3.89-6.42-.31,3.54-3.43,6.16-6.97,5.85-2.37-.21-4.44-1.71-5.37-3.9l-6.88-15.49h-14.61Zm-28.41,35.97v1.07l22.62,12.57c3.09,1.76,7.02,.68,8.78-2.41,.65-1.14,.93-2.44,.82-3.75-.28,3.54-3.39,6.19-6.93,5.9-.94-.07-1.85-.35-2.67-.82l-22.62-12.57Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.85563083fb4b49ca434d926210a5d8c8.svg";
export { ForwardRef as ReactComponent };